import { Injectable } from '@angular/core';
import { BaseService} from './base.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoService extends BaseService {

  constructor(
    private http: HttpClient
  ) {super();}

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8',
                              Authorization: 'my-auth-token', }),
    params: {}
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
    }
    return throwError(errorMessage);
  };

  getAcompanhamento(cpf : string, inscricao : string) : Observable<any>{

    const url = this.UrlService+'acompanhamento/Acompanhamento/?cpf='+cpf+'&inscricao='+inscricao;
    return this.http.get<any>(url,this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  enviarDocs(objAcompanhamento : any): Observable<any>{
    return this.http.post<any>(this.UrlService+'Documento/Gravar', objAcompanhamento)
      .pipe(catchError(this.handleError));

  }

  retornaBoletoBinario(cpf: string,codinscr : string): Observable<any> {

    const url = this.UrlService+'Boleto/emitirBoleto/' + cpf+'/'+codinscr;
    return this.http.get<any>(url,this.httpOptions)
    .pipe( catchError(this.handleError));
  }

}
